import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export class CustomValidators {
  static validFirstName(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return null;
      }

      const isValid = /^[A-ZÀ-ÿ][a-zA-ZÀ-ÿ\- ']{0,28}$/.test(value);

      return !isValid ? { validFirstName: true, message: 'Should be a name containing a leading capital letter', isCustom: true } : null;
    };
  }

  static requiredWithCtrlRequiredToEqual(ctrlNameToCheck: string, valueToCheck: unknown): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const parentCtrl = control.parent;

      if (!parentCtrl) {
        return null;
      }

      const valueToCompareWith = parentCtrl.get(ctrlNameToCheck)?.value;

      const isValid = !!control.value && valueToCompareWith === valueToCheck;

      return !isValid ? { requiredWhenEqual: true } : null;
    };
  }

  static requiredIf(ctrlNameToCheck: string, valueToCheck: unknown): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const parentCtrl = control.parent;

      if (!parentCtrl) {
        return null;
      }

      const valueToCompareWith = parentCtrl.get(ctrlNameToCheck)?.value;

      if (Array.isArray(valueToCheck)) {
        if (!valueToCheck.includes(valueToCompareWith)) {
          return null;
        } else {
          return Validators.required(control);
        }
      }

      if (valueToCompareWith !== valueToCheck) {
        return null;
      }

      return Validators.required(control);
    };
  }

  static requiredTrueIf(ctrlNameToCheck: string, valueToCheck: unknown): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const parentCtrl = control.parent;

      if (!parentCtrl) {
        return null;
      }

      const valueToCompareWith = parentCtrl.get(ctrlNameToCheck)?.value;

      if (Array.isArray(valueToCheck)) {
        if (!valueToCheck.includes(valueToCompareWith)) {
          return null;
        } else {
          return Validators.requiredTrue(control);
        }
      }

      if (valueToCompareWith !== valueToCheck) {
        return null;
      }

      return Validators.requiredTrue(control);
    };
  }
}
